import { createUseStyles } from 'react-jss';
import { color, fontSize, radius, spacing } from '@blink/components';

export const useAssetInputStyle = createUseStyles({
    root: {
        background: color.background.secondary,
        display: 'flex',
        flexDirection: 'column',
        border: `1px solid ${color.border.opaque}`,
        borderRadius: 4,
        padding: `${spacing['05']}`,
        '&:active': {
            borderColor: color.border.selected,
        },
        '&:focus': {
            borderColor: color.border.selected,
        },
        '&:focus-within': {
            borderColor: color.border.selected,
        },
        '&.error': {
            borderColor: color.content.negative,
            '& .title': {
                color: color.content.negative,
            },
        },
        '& img': {
            width: 28,
            height: 28,
        },
    },
    balanceWrapper: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        gap: spacing['01'],
    },
    infoWrapper: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: spacing['03'],
    },
    balance: {
        color: color.content.primary,
        marginLeft: spacing['02'],
    },
    footer: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    assetName: {
        fontSize: fontSize.xl,
    },
    input: {
        display: 'flex',
        width: '100%',
        margin: `0 ${spacing['04']} 0 0`,
        alignItems: 'center',
        '& .ant-input': {
            width: '100%',
            fontSize: fontSize.xl,
            borderColor: 'transparent',
            backgroundColor: 'inherit',
            textAlign: 'end',
            lineHeight: 0.5,
            padding: '0 !important',
        },
        '& .ant-input:hover': {
            borderColor: 'transparent',
        },
        '& .ant-input-outlined:focus': {
            boxShadow: 'none',
        },
        '& input': {
            textAlign: 'start !important',
        },
        '& .ant-input::placeholder': {
            color: color.content.secondary,
        },
        '& .ant-input:focus::placeholder': {
            color: color.content.primary,
        },
    },
    borrowApyWrapper: {
        display: 'flex',
        justifyContent: 'space-between',
        gap: spacing['02'],
    },
    borrowApy: {
        display: 'flex',
        alignItems: 'center',
        gap: spacing['04'],
        color: color.content.secondary,
    },
    borrowApyNumber: {
        fontWeight: 600,
    },
    borrowImg: {
        width: 24,
        height: 24,
    },
    inputWrapper: {
        display: 'flex',
        marginRight: `${spacing['07']}`,
    },
    text: {
        color: color.content.primary,
        fontWeight: 600,
    },
    textBtn: {
        color: color.content.accent,
        cursor: 'pointer',
        fontWeight: 600,
    },
    icon: {
        display: 'flex',
        alignSelf: 'center',
        marginLeft: spacing['02'],
        color: color.content.primary,
    },
    tooltipRoot: {
        borderRadius: radius.overall,
        width: 'fit-content',

        '& .ant-tooltip-arrow': {
            top: 1,
        },
        '& .ant-tooltip-inner': {
            display: 'flex',
            minWidth: 96,
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'flex-start',
            gap: spacing['02'],
            padding: '8px 12px',
            border: `1px solid transparent`,
            background: `${color.background.inversePrimary} !important`,
        },
        '& .ant-tooltip-arrow:before': {
            background: `${color.background.inversePrimary} !important`,
        },
        '&.ant-tooltip': {
            fontSize: `${fontSize.sm} !important`,
            maxWidth: 320,
            color: color.content.inversePrimary,
        },
        '& svg': {
            cursor: 'pointer',
        },
    },
    title: {
        display: 'flex',
        alignItems: 'center',
        color: color.content.fourth,
        fontSize: 14,
    },
});
